import { render, staticRenderFns } from "./HomeLatestClients.vue?vue&type=template&id=1fcaa448"
import script from "./HomeLatestClients.vue?vue&type=script&lang=js"
export * from "./HomeLatestClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports